/**
 * Legacy OrganizationsApiService module — preserved as an empty AngularJS
 * module so existing dependencies (`acme.common.service.organizationsApi`)
 * keep resolving.
 *
 * The actual OrganizationsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/organizations/organizations-api.service.ts
 */
angular.module("acme.common.service.organizationsApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
